import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import { getManagementStatusBadgeColors } from '../utils/formatters';
import styles from './CouponCodes.module.scss';
export const createCouponColumns = (_handleView, _handleDelete, handleToggleIsActive) => [
    {
        key: 'promo_code',
        header: 'Promo Code',
        sortable: true,
        render: (promo) => (_jsx("span", { className: styles.couponCode, children: promo.promo_code })),
    },
    {
        key: 'description',
        header: 'Description',
        sortable: true,
        render: (promo) => promo.description || 'N/A',
    },
    {
        key: 'discount_amount',
        header: 'Discount Amount',
        sortable: true,
        render: (promo) => {
            const amount = parseFloat(String(promo.discount_amount)) || 0;
            return promo.discount_type === 'percent'
                ? `${amount}%`
                : `$${amount.toFixed(2)}`;
        },
    },
    {
        key: 'discount_type',
        header: 'Discount Type',
        sortable: true,
        render: (promo) => promo.discount_type,
    },
    {
        key: 'status',
        header: 'Status',
        sortable: false,
        render: (promo) => {
            const statusLabel = !promo.is_active
                ? 'Inactive'
                : !promo.is_valid_date_range
                    ? 'Expired'
                    : !promo.is_usage_available
                        ? 'Used Up'
                        : 'Active';
            const { background, text } = getManagementStatusBadgeColors(statusLabel);
            return (_jsx(StatusBadge, { label: statusLabel, bgColor: background, color: text }));
        },
    },
    {
        key: 'products',
        header: 'Products',
        sortable: false,
        render: (promo) => {
            const count = Array.isArray(promo.products) ? promo.products.length : 0;
            if (count === 0)
                return 'Order-wide';
            return `${count} product${count === 1 ? '' : 's'}`;
        },
    },
    {
        key: 'usage_count',
        header: 'Usage Count',
        sortable: true,
        render: (promo) => promo.usage_count ?? 0,
    },
    {
        key: 'usage_limit',
        header: 'Usage Limit',
        sortable: true,
        render: (promo) => promo.usage_limit ?? 0,
    },
    {
        key: 'is_active',
        header: 'Is Active',
        sortable: true,
        render: (promo) => (_jsx("input", { type: "checkbox", checked: !!promo.is_active, onClick: (event) => event.stopPropagation(), onChange: (event) => handleToggleIsActive(promo, event.target.checked) })),
    },
];
